import React, { useState, useEffect, useCallback } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../iconos/IconosGenerales";
import { fetchObtenerPublicacion, fetchEditarPublicacion } from '../../../peticiones_API/PeticionesPublicaciones';
import ErrorForm from '../eventos/avisos/Alerta';
import { useParams } from "react-router-dom";
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidationFormCategoria';
import { DatosCorrectos, CategoriaExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import CalendarioForm from '../basicos/CalendarioForm';
import EditorDeTextoCompleto from '../basicos/EditorDeTextoCompleto';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import {MdEdit} from "react-icons/md";

import { fetchObtenerCategoriasPublicaciones } from '../../../peticiones_API/PeticionesCategoriasPublicaciones';
import { fetchObtenerWebsDestino } from '../../../peticiones_API/PeticionesWebsDestino';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


const FormEditarPublicacion = ({ usuarioLogueado }) => {

    const { Id } = useParams(); 
    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);
    const [errorCargaImagen, setErrorCargaImagen] = useState(false);
    const [imagenServidor, setImagenServidor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        titulo: '',
        url: '',
        imgPortada: null,
        contenido: '',
        imagenesContenido: [],
        creador: '',
        editor: '',
        fechaPublicacion: dayjs(),
        visible: true,
        webDestino: [],
        categoria: null,
        tituloIngles: '',
        contenidoIngles: ''
    });

    //Categorias_publicaciones
    const [categoriasPubli, setCategoriasPubli] = useState([]);

    //Webs de destino
    const [WebsDestino, setWebsDestino] = useState([]); //Estado para la categoría

    const camposRequeridos = {
        titulo: "Debes insertar un nombre",
        imgPortada: "Debes adjuntar una imagen"
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        titulo: null,
        imgPortada: null
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [enviado, setEnviado] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        publicacionDuplicada: null,
    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);
        setEnviado(true);

        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    const cargarCategorias = useCallback(async () => {
        try {
            const datos = await fetchObtenerCategoriasPublicaciones();
            setCategoriasPubli(datos);
        } catch (error) {
            console.error("Error al cargar categorías:", error);
        }
    }, []);
    

    const cargarWebsDestino = useCallback(async () => {
        try {
            const datos = await fetchObtenerWebsDestino();
            setWebsDestino(datos);
        } catch (error) {
            console.error("Error al cargar webs de destino:", error);
        }
    }, []);

    const [tabActual, setTabActual] = useState(0);

     //Ejecutarlas 1 vez al cargar el componente
    useEffect(() => {
        cargarWebsDestino();
        cargarCategorias();   
    }, [cargarCategorias, cargarWebsDestino]);

    useEffect(() => {
        async function fechtPrincipal() {
            try {
                if (!usuarioLogueado?.id) {
                    return;
                }

                const publicacion = await fetchObtenerPublicacion(Id);
                //console.log("listado", publicacion);

              const urlLimpia = publicacion.url
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") // quitar acentos
                .replace(/[^a-z0-9-]+/g, "-") // reemplazar todo lo que no sea letra, número o guion por guion
                .replace(/-+/g, "-") // evitar guiones repetidos
                .replace(/^-|-$/g, "") // quitar guiones al inicio/fin
                .toLowerCase();

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IdPublicacion: publicacion.Id,
                    titulo: publicacion.titulo,
                    url: urlLimpia,
                    imgPortada: publicacion.imgPortada,
                    imgPortadaAnterior: publicacion.imgPortada,
                    contenido: publicacion.contenido,
                    contenidoAnterior: publicacion.contenido,
                    imagenesContenido: publicacion.contenidoImgs && publicacion.contenidoImgs.length > 0 ? [...publicacion.contenidoImgs] : [],
                    creador: publicacion.creador.Id,
                    editor: usuarioLogueado?.id || '',
                    fechaPublicacion: publicacion.fechaPublicacion,
                    visible: publicacion.visible,
                    categoria: publicacion.categoria,
                    webDestino: publicacion.webDestino,
                    tituloIngles: publicacion.tituloIngles,
                    contenidoIngles: publicacion.contenidoIngles, 
                    img: publicacion.img            
                }));

                const campos = [
                    'titulo', 'url', 'imgPortada'
                ];

                campos.forEach(campo => {
                    if (publicacion[campo] != null) {
                        setEstadoCampoReque(prevState => ({
                            ...prevState,
                            [campo]: false
                        }));
                    }
                });

                setImagenServidor(`${process.env.REACT_APP_API_URL}/api/comunicacion/blogs/imagen/${publicacion.Id}/${publicacion.imgPortada}`);
                setPrevisualizacionImg(`${process.env.REACT_APP_API_URL}/api/comunicacion/blogs/imagen/${publicacion.Id}/${publicacion.imgPortada}`);
                setErrorCargaImagen(false);
                setLoading(false);

            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [Id, usuarioLogueado?.id]);

    useEffect(() => {
        if (imagenServidor) {
            const img = new Image();
            img.onload = () => {
                setErrorCargaImagen(false);
            };
            img.onerror = () => {
                setErrorCargaImagen(true);
                setPrevisualizacionImg(null);
            };
            img.src = imagenServidor;
        }
    }, [imagenServidor]);

    useEffect(() => {

        const portadaImgElement = document.getElementById("portada_blog_img");
        let valorImg = portadaImgElement ? portadaImgElement.value : '';
        const f = new Date();
        const dia = ('0' + f.getDate()).slice(-2);
        const mes = ('0' + (f.getMonth() + 1)).slice(-2);
        const año = f.getFullYear();
        const hora = ('0' + f.getHours()).slice(-2);
        const minutos = ('0' + f.getMinutes()).slice(-2);
        const segundos = ('0' + f.getSeconds()).slice(-2);

        if (formData.imgPortada === null && valorImg !== '') {

            const imgPortada = `${dia}${mes}${año}${hora}${minutos}${segundos}_portada_blog_img`;

            setFormData(prevFormData => ({ ...prevFormData, imgPortada: imgPortada }));
        }

        if (estadosActualizados && enviado) {
            //console.log("formData", formData);
            console.log("estadoCampoReque", estadoCampoReque);

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    //console.log("Simulacion editar publicacion");

                    try {
                        const resultado = await procesarImagenesParaEnvio(formData.contenido);
                        const imagenesFinales = [
                            ...formData.imagenesContenido,
                            ...resultado.imagenesParaEnviar
                        ];
                        const datosParaEnviar = {
                            ...formData,
                            contenido: resultado.contenidoActualizado,
                            imagenesContenido: imagenesFinales
                        };

                        const response = await fetchEditarPublicacion(datosParaEnviar);
                        //console.log("Publicación editada:", response);

                    } catch (error) {
                        //console.log(error?.response?.data?.error);

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'categoria existe') {

                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, publicacionDuplicada: true }));
                        }


                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEnviado(false);
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque, enviado]);


    const handleTabChange = (event, newValue) => {
        setTabActual(newValue);
    };

    const handleChange = (event) => {
        setErrorEnviarForm({ publicacionDuplicada: false });

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value, type, files } = event.target;

        let newValue;

        newValue = value;
        if (type === 'file') {
            newValue = files[0];
        }
        else {
            newValue = value;
        }


        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();

            if (name === 'portada_blog_img') {
                reader.onloadend = () => {
                    setPrevisualizacionImg(reader.result);
                    setErrorCargaImagen(false);
                };
                reader.onerror = () => {
                    setErrorCargaImagen(true);
                    setPrevisualizacionImg(null);
                };
                reader.readAsDataURL(file);
            }
        }

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        setFormData(prevFormData => ({ ...prevFormData, url: formData.titulo.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").toLowerCase() }));

        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

    };

    const handleDelete = () => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        setPrevisualizacionImg(null);
        setErrorCargaImagen(false);
        setImagenServidor(null);
        document.getElementById("portada_blog_img").value = "";
        delete formData.imgPortada;

    };

    const handleEditorChange = useCallback((content) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        //console.log('Contenido del editor recibido:', content);
        setFormData(prevFormData => {
            if (prevFormData.contenido === content) return prevFormData;
            return { ...prevFormData, contenido: content };
        });
    }, []);

    const handleEditorInglesChange = useCallback((content) => {
            setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

            setFormData(prevFormData => {
                if (prevFormData.contenidoIngles === content) return prevFormData;
                return { ...prevFormData, contenidoIngles: content };
            });
    }, []);

    const procesarImagenesParaEnvio = async (contenidoHTML) => {
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(contenidoHTML, 'text/html');
        const imagenes = doc.querySelectorAll('img[data-filename]');
        
        //console.log(`Encontradas ${imagenes.length} imágenes con data-filename para procesar`);
        
        const nuevasImagenes = [];
        
        for (let i = 0; i < imagenes.length; i++) {
            const img = imagenes[i];
            const dataFilename = img.getAttribute('data-filename');
            const srcBase64 = img.getAttribute('src');
            
            //console.log(`Procesando imagen ${i + 1}: ${dataFilename}`);
            
            if (dataFilename && srcBase64 && srcBase64.startsWith('data:')) {
                try {
                    const response = await fetch(srcBase64);
                    const blob = await response.blob();
                    
                    const file = new File([blob], dataFilename, { type: blob.type });
                    
                    nuevasImagenes.push({
                        nombre: dataFilename,
                        file: file
                    });
                    
                    img.setAttribute('src', dataFilename);
                    img.removeAttribute('data-filename');
                    
                } catch (error) {
                    console.error(`Error procesando imagen ${dataFilename}:`, error);
                }
            }
        }
        
        const contenidoFinal = doc.body.innerHTML;

        return {
            contenidoActualizado: contenidoFinal,
            imagenesParaEnviar: nuevasImagenes
        };
    };

    if(loading) return <div>Cargando...</div>;



    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="EDITAR PUBLICACIÓN"
                        bonificados="true"
                    />

                    <Boton
                    bonificados="true"
                    grande="true"
                    as="button"
                    primario="true"
                    type="submit"
                    onClick={handleSubmit}
                    form="true"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                    Guardar y Salir{<MdEdit style={{marginLeft:'8px'}}/>}
                    </Boton>
                </CabeceraForm>

                <Col md={{ span: 10, offset: 1 }}>
                    <ToastContainer /> 


                    <Row style={{marginBottom:'60px'}}>

                        <Col className="d-flex justify-content-center"> {/*height:250px  width:410 */}
                                <ContenedorImagen >

                                    <TituloPrincipal>
                                        <Form.Control
                                            type="file"
                                            id="portada_blog_img"
                                            accept=".jpg,.jpeg,.png,.webp"
                                            name="portada_blog_img"
                                            onChange={handleChange}
                                        />
                                        <ErrorForm mensaje={camposRequeridos.imgPortada} estadoAlerta={estadoCampoReque.imgPortada} />
                                    </TituloPrincipal>
                                     {previsualizacionImg && !errorCargaImagen ? (
                                             <IconosGenerales alerta="true" id="delete" onClick={handleDelete} />
                                        ) : (<></>)}

                                    <img
                                        src={previsualizacionImg || ImagenDefault}
                                        alt="Vista previa"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: 'auto',
                                            objectFit: 'contain',
                                        }}
                                        onError={(e) => {
                                            if (imagenServidor && e.target.src === imagenServidor) {
                                                setErrorCargaImagen(true);
                                                setPrevisualizacionImg(null);
                                            }
                                        }}
                                        onLoad={(e) => {
                                            if (!imagenServidor && e.target.src.startsWith('data:')) {
                                                setErrorCargaImagen(false);
                                            }
                                        }}
                                    />

                                </ContenedorImagen>
                        </Col>

                        <Col className=" d-flex flex-column justify-content-center "> {/*height:250px  width:410 */}

                            <ContenedorDatosPublicacion>

                                <InputContainer style={{width:'100% !important', paddingTop: '0px', marginTop:'0px'}} >
                                    <LabelBorde  fechaValue={!!formData.fechaPublicacion}>Fecha publicación</LabelBorde>
                                    <CalendarioBorde value={formData.fechaPublicacion} etiqueta="" fechaPublicacion={formData.fechaPublicacion} />
                                </InputContainer>


                                <Autocomplete
                                    size="small"
                                    sx={{ width: '100% !important' }}
                                    options={categoriasPubli.filter(p => p.activo !== false).sort((a, b) => `${a.categoria}`.localeCompare(`${b.categoria}`))}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => `${option.categoria}`}
                                    value={formData.categoria ? categoriasPubli.find(c => c.Id === formData.categoria) : null}
                                    onChange={(e, newValue) => ( setFormData(prevFormData => ({ ...prevFormData, categoria: newValue?.Id })) )}
                                    renderOption={(props, option, { selected }) => (
                                        <Li checked={selected} {...props}>
                                        {option.categoria}
                                        </Li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Categoría" placeholder="Seleccionar..." />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                                />

                                <Autocomplete
                                    multiple
                                    size="small"
                                    limitTags={1}
                                    sx={{ width: '100% !important' }}
                                    options={WebsDestino.filter(p => p.activo !== false).sort((a, b) => `${a.destino}`.localeCompare(`${b.destino}`))}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => `${option.destino}`}
                                    value={formData.webDestino ? WebsDestino.filter(web => formData.webDestino.includes(web.Id)) : []}
                                    onChange={(e, newValue) => ( setFormData(prevFormData => ({ ...prevFormData, webDestino: newValue.map(v => v.Id).toString()})) )}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props} checked>
                                        <Checkbox
                                            size="small"
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.destino}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Destino" placeholder="Seleccionar..." />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                                />

                            </ContenedorDatosPublicacion>
                           
                        </Col>
                        
                    </Row>

                    <Row>
                        <Box sx={{ mb: 1 }}>
                                <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', color: '#336385', mb: 2 }}>
                                    Contenido de la publicación 
                                </Typography>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs
                                value={tabActual}
                                onChange={handleTabChange}
                                sx={{
                                    '& .MuiTab-root': {
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    fontSize: '1rem'
                                    },
                                    '& .Mui-selected': {
                                    color: '#336385'
                                    },
                                    '& .MuiTabs-indicator': {
                                    backgroundColor: '#336385'
                                    }
                                }}
                                >
                                    <Tab  iconPosition="start" label="Español" />
                                    <Tab  iconPosition="start" label="Inglés" />
                                </Tabs>
                            </Box>
                        </Box>
                    </Row> 

                    <Row md="5" className="align-items-center d-flex justify-content-center mt-5">
                        {tabActual === 0 && (
                            <Row style={{width:'100%'}} className="align-items-center d-flex flex-column justify-content-center mt-5">
                                <InputContainer style={{width:'70%'}} >
                                    <LabelBorde hasValue={!!formData.titulo}>Título</LabelBorde>

                                    <InputBorde
                                        type="name"
                                        name="titulo"
                                        value={formData.titulo || ''}
                                        onChange={handleChange}
                                    />

                                    <ErrorForm 
                                        mensaje={camposRequeridos.titulo} 
                                        estadoAlerta={estadoCampoReque.titulo} 
                                    />
                                </InputContainer>




                                <Col >                                  
                                    <Form.Group className="mb-1 mb-6">
                                        <TituloCategoria>Contenido</TituloCategoria>
                                        <EditorDeTextoCompleto
                                        contenidoRecibido={formData.contenido}
                                        imagenesRecibido={formData.imagenesContenido}
                                        onContentChange={handleEditorChange} />
                                    </Form.Group>               
                                </Col>

                            </Row>
                        )}

                        {tabActual === 1 && (
                            <Row style={{width:'100%'}} className="align-items-center d-flex flex-column justify-content-center mt-5">
                                <InputContainer style={{width:'70%'}} >
                                    <LabelBorde hasValue={!!formData.tituloIngles}>Title...</LabelBorde>

                                    <InputBorde
                                        type="text"
                                        name="tituloIngles"
                                        value={formData.tituloIngles|| ''}
                                        onChange={handleChange}
                                    />
                                </InputContainer>
                                <Col >                                  
                                    <Form.Group className="mb-1 mb-6">
                                        <TituloCategoria>Content</TituloCategoria>
                                        <EditorDeTextoCompleto
                                        contenidoRecibido={formData.contenidoIngles}
                                        imagenesRecibido={formData.imagenesContenidoIngles}
                                        onContentChange={handleEditorInglesChange} placeholder="Enter the content in English..." />
                                    </Form.Group>               
                                </Col>
                                
                            </Row>
                        )}
                    </Row>

                    <Row >
                        <Col >
                            <ContenedorBotones>

                                <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                name="guardar_cambios_statico"
                                >
                                    Guardar{<MdEdit style={{marginLeft:'8px'}}/>}
                                </Boton>

                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    to="/comunicacion/blogs"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Col>
                    </Row>
                    
                </Col>

            </Form>

            {botonRenderClick ? 
                <DatosCorrectos envioActivado={formCompletado} />         
                :             
                <DatosCorrectos envioActivado={formCompletado} redirect={false} />
            }

            <DatosIncorrectos envioActivado={formCompletado} />
            <CategoriaExistente envioActivado={errorEnviarForm.publicacionDuplicada} />
        </>
    );
}

const CabeceraForm = styled.div`
    display:flex;
    margin-left:10%;
    width: 80%;
    justify-content:space-between;
    align-items:center;
    margin-bottom: 2%;
`

const ContenedorBotones = styled.div`
    margin-top: 1%;
        display: flex;
     justify-content: center;
     gap: 10px; 
     
    @media screen and (max-width: 1200px) {
    margin-top: 35px !important;
    }
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`
const TituloPrincipal = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

const ContenedorDatosPublicacion = styled.div`
    width: 100% !important;
    height: 60% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;

    @media screen and (max-width: 1400px) {
        width: 100% !important;
        height: 150px !important;

    }
`

//Cambios
const ContenedorImagen = styled.div `
width:500px;
height: auto;
margin-top:20px; 
margin-bottom:90px; 
display:flex; 
justify-content: center;
align-items:center;
flex-direction: column;


@media screen and (max-width: 1400px) {
    width:550px;
    margin-bottom:40px; 
}

@media screen and (max-width: 1100px) {
    width:500px;
}

@media screen and (max-width: 650px) {
    width:400px;
}

`

export const InputContainer = styled(Form.Group)`
  position: relative;
  margin-top: 1.5rem;
  display:flex;
  justify-content:start;
  align-items:center;


   &:focus {
    box-shadow: none;
  }
`;

export const LabelBorde = styled.label`
  position: absolute;
  z-index: 5;
  background: white;
  font-size: 16px;
  margin-left: 12px;
  color: #9b9a9a !important;
  font-weight: 500;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;
  
  

  /* Cuando el input está en foco */
  ${InputContainer}:focus-within & {
    transform: translateY(-20px);
    font-size: 12px;
    color: #2587d8;
  }

  /* Cuando tiene valor */
  ${({ hasValue }) =>
    hasValue &&
    `
      transform: translateY(-20px);
      font-size: 12px;
      color: #868383;
    `}

    ${({ fechaValue }) =>
    fechaValue  &&
    `
      transform: translateY(-20px);
      font-size: 12px;
      color: #868383;
    `}
`;

export const InputBorde = styled(Form.Control)`
  padding: 10px;
  border: 1px solid #b3acac !important;
  box-shadow: none;

  &:focus,
  &:focus-visible {
    border: 1px solid #000;
    box-shadow: none !important;
    outline: none !important;
  }

  &:hover{
    border: 1px solid #000 !important;
  }
`;

export const CalendarioBorde = styled(CalendarioForm)`
  padding: 10px;
  border: 1px solid #868383;
  box-shadow: none;

  &:focus,
  &:focus-visible {
    border: 1px solid #000;
    box-shadow: none !important;
  }
`;


export const Li = styled.li`
  background: white;

    &:hover {
        background: #b9b9b9 !important;
    }

    ${({ checked }) =>
    checked &&
    `
      background: #a7a5a5 !important;
    `}
`;


export default FormEditarPublicacion;